
import warning from "./warning";
import sensor from './sensor';
import user from './user';
import elevator from './elevator';
import yysy from './yysy';

export default {
  warning,
  sensor,
  user,
  elevator,
  yysy
}



// WEBPACK FOOTER //
// ./src/api/index.js